<script setup lang="ts">
import MlPoweredBy from 'components/sections/layout/MlPoweredBy.vue'
</script>
<template>
  <q-layout container style="height: 100vh" class="bg-body">
    <q-page-container>
      <q-page class="flex flex-column justify-center items-center">
        <div
          class="column justify-center items-center full-height q-pa-sm"
          style="height: 100%"
        >
          <q-card
            flat
            class="q-pa-sm rounded-borders border-primary text-center"
          >
            <div class="flex justify-center q-gutter-x-sm">
              <q-icon
                size="xs"
                color="primary"
                name="report_problem"
                class="self-center"
              ></q-icon>
              <span
                class="text-primary text-overline self-center"
                style="line-height: 24px"
                >{{ $t('unsupported_screen_size.title') }}</span
              >
            </div>
            <div
              class="text-body text-overline text-weight-regular"
              style="line-height: 18px"
            >
              {{ $t('unsupported_screen_size.text') }}
            </div>
          </q-card>
        </div>
      </q-page>
    </q-page-container>
    <q-footer>
      <MlPoweredBy></MlPoweredBy>
    </q-footer>
  </q-layout>
</template>
